import { get } from 'utils/api';

export const fetchCustomerId = () => get<string>('getId', {});
